export const isExpectedAuthenticationFailure = error =>
	error?.__suppressSentry === true

export const recoverExpectedAuthenticationFailure = (error, fallback) => {
	if (isExpectedAuthenticationFailure(error)) {
		return fallback
	}

	throw error
}
